import { anzeigeNummer, zweitNummer } from '@/lib/bestellnummer';

// Der Minimal-Bestellzettel (B3) — gemeinsam für die Druckseite mit
// Sitzung (/bestellungen/…/druck) und den iPhone-Druck in Safari
// (/drucken/…). Eine Stelle, damit beide Wege dasselbe Papier ergeben.

export type ZettelDaten = {
  bestellnr: string;
  shopify_order_number?: string | null;
  ist_uebung: boolean;
  kunde: { anzeigename: string };
};

export function ZettelBlatt({ b }: { b: ZettelDaten }) {
  // Die Nummer im Pfad kodieren, nicht roh einsetzen. Übungsnummern
  // tragen ein Ü; im QR-Code steht dann `%C3%9C` statt eines Umlauts.
  // Das hält den Code rein ASCII — alte Handscanner tun sich mit
  // UTF-8-Inhalten schwer — und lässt ihn durch die Zeichenprüfung von
  // qr.php, die den dekodierten Text sieht.
  const qrZiel = `${window.location.origin}/s/${encodeURIComponent(b.bestellnr)}`;
  const qrBild = `/api/qr.php?d=${encodeURIComponent(qrZiel)}`;
  const zweit = zweitNummer(b);

  // Der eigentliche Zettel. Mehr steht hier bewusst nicht.
  //
  // OBEN LINKS, KLEIN (A5.3)
  // Das A4-Blatt wird gefaltet ins Buch gelegt, sodass ein Rand
  // herausschaut. Was auf diesem Rand steht, muss lesbar und
  // scanbar sein, ohne das Buch aufzuschlagen — deshalb sitzt der
  // QR-Code in der oberen linken Ecke und nicht mittig.
  //
  // Der Inhalt bleibt der Minimal-Zettel: QR, Nummer, Kunde.
  // Nichts kommt hinzu (Prinzip: nichts, was zum Draufschreiben
  // einlaedt).
  //
  // `min-h` gibt dem Uebungs-Wasserzeichen Raum: Es spannt sich
  // ueber diesen Kasten, und mit dem kleineren QR waere der Kasten
  // sonst zu flach fuer den schraegen Schriftzug.
  return (
    <div className="zettel relative flex min-h-[55mm] w-full flex-col items-start text-left">
      {b.ist_uebung && (
        <div className="uebung-wasserzeichen" aria-hidden>
          <span>ÜBUNG</span>
        </div>
      )}
      {/* 25 mm Kantenlaenge, gerechnet statt geschaetzt.

          Der Code aus qr.php misst 33 x 33 Module, dazu je vier Module
          Ruhezone — 41 Module ueber die Kante (am erzeugten Bild
          nachgemessen: 246 px bei 6 px je Modul). Bei 25 mm ist ein
          Modul 0,61 mm gross. Die Faustregel fuer Handykameras
          verlangt mindestens 0,5 mm; auf dem Laserdrucker sind das
          7,2 Druckpunkte je Modul bei 300 dpi, 14,4 bei 600.

          Der uebliche Lese-Abstand ist etwa das Zehnfache der
          Kantenlaenge — bei 25 mm also rund 25 cm, genau die Haltung,
          in der jemand ein Blatt vor sich haelt.

          Kleiner waere heikel: 20 mm ergaeben 0,49 mm je Modul und
          damit genau die Grenze. */}
      <img
        src={qrBild}
        alt={`QR-Code zu ${b.bestellnr}`}
        className="h-[25mm] w-[25mm]"
      />

      <div className="mt-3 font-mono text-[20pt] font-bold leading-none">
        {anzeigeNummer(b)}
      </div>
      {zweit && (
        <div className="mt-1 font-mono text-[11pt] leading-none text-neutral-700">
          {zweit}
        </div>
      )}

      <div className="mt-3 text-[13pt] leading-tight">{b.kunde.anzeigename}</div>
    </div>
  );
}
